import { LibraryDeleteFolderDialogUi } from "generated/graphql";

const initialState: LibraryDeleteFolderDialogUi = {
	open: false,
	libraryId: null,
	path: ''
};

export default initialState;